import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useMutation, Types } from "@grandvisionhq/graphql";
import "../../operations/fragments/operations/fragments/cart-details.js";
import "../../operations/fragments/operations/fragments/loyalty-point-failure.js";
import { SET_LOYALTY_DETAILS } from "../../operations/mutations/operations/mutations/set-loyalty-details.js";
const useSetLoyaltyDetails = ({ onError, onCompleted } = {}) => {
  const handleOnCompleted = React.useCallback(
    (responseData) => {
      let result;
      if (responseData.setLoyaltyDetails) {
        result = responseData.setLoyaltyDetails;
        if (result.success) {
          onCompleted?.("MUTATION");
          result?.cart?.loyaltyDetails.cardNumberType == "LUHN" && toast.success("cart.loyaltyCardUpdate.success");
        }
        if (result.failures?.length) {
          result.failures.forEach(
            (item) => {
              switch (item.__typename) {
                case "UnknownSetLoyaltyDetailsFailure":
                  console.error(
                    `useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`
                  );
                  toast.failed("cart.errors.loyaltyCardUpdate.failed");
                  return;
                case "InvalidLoyaltyCardNumber":
                  console.error(
                    `useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`
                  );
                  toast.failed("cart.loyalty.invalidNumber");
                  return;
                default:
                  console.error(
                    `useSetLoyaltyDetails:[${item.code}] failed to setLoyaltyCardDetails: ${item.message}`
                  );
                  toast.failed("cart.errors.loyaltyCardUpdate.failed");
              }
            }
          );
        }
      }
    },
    [onCompleted]
  );
  const handleOnError = React.useCallback(
    (e) => {
      console.error("useSetLoyaltyDetails:", e);
      onError?.({ reason: "MUTATION" });
      toast.failed("cart.errors.loyaltyCardUpdate.failed");
    },
    [onError]
  );
  const [setLoyaltyDetails, setLoyaltyDetailsMutation] = useMutation(SET_LOYALTY_DETAILS, {
    onCompleted: handleOnCompleted,
    onError: handleOnError
  });
  const setLoyaltyCardNumber = React.useCallback(
    async (cardNumber, cartId, cartHash, type) => {
      if (!cartId) {
        console.error("CartId required to perform update ");
        return;
      }
      await setLoyaltyDetails({
        variables: {
          input: {
            cardNumber,
            cartId,
            cardNumberType: type ?? Types.LoyaltyCardNumber.LUHN
          }
        },
        ...cartHash ? { context: { forwardHeaders: { "cart-hash": cartHash } } } : {}
      });
    },
    [setLoyaltyDetails]
  );
  const { loading, error } = setLoyaltyDetailsMutation;
  return { setLoyaltyCardNumber, isUpdating: loading, updateError: error };
};
export {
  useSetLoyaltyDetails
};
//# sourceMappingURL=use-set-loyalty-details.js.map
